import React, { useEffect, useState } from 'react';

import aguid from 'lib/aguid';
import GroupVsRemainderForm from './GroupVsRemainderForm';

const GroupVsRemainderFormContainer = ({
  gadget,
  onChange,
}: {
  gadget: VisualisationDefinitions.GroupVsRemainder | undefined;
  onChange?: React.Dispatch<
    React.SetStateAction<VisualisationDefinition | undefined>
  >;
}) => {
  // Base
  const [isNewGadget] = useState<boolean>(!gadget);
  const [id] = useState(gadget ? gadget.id : aguid());
  const [name, setName] = useState<string>(gadget ? gadget.name : '');
  const [dataset, setDataset] = useState<string | undefined>(gadget?.dataset);
  const [field, setField] = useState<string | undefined>(gadget?.field);
  const [peerGroup, setPeerGroup] = useState<string | undefined>(
    gadget?.peerGroup,
  );
  const [description, setDescription] = useState<string>(
    gadget ? gadget.description : '',
  );
  const [interval, setInterval] = useState<FleetOps.Interval | FiscalInterval>(
    gadget?.trendByCalendarInterval || 'auto',
  );
  const [, setDraftGadget] = useState<
    VisualisationDefinitions.GroupVsRemainder | undefined
  >();
  const [maxY, setMaxY] = useState<number | undefined>(gadget?.maxY);
  const [minY, setMinY] = useState<number | undefined>(gadget?.minY);
  const [minYBehaviour, setMinYBehaviour] = useState<'auto' | 'set'>(
    gadget?.minYBehaviour || 'auto',
  );
  const [maxYBehaviour, setMaxYBehaviour] = useState<'auto' | 'set'>(
    gadget?.maxYBehaviour || 'auto',
  );
  const [useEntityAsScope, setUseEntityAsScope] = useState<boolean>(
    gadget?.useEntityAsScope ?? false,
  );

  useEffect(() => {
    const newDraftGadget = (() => {
      if (!field || !dataset || name === '') {
        return undefined;
      } else {
        return {
          id,
          name,
          description,
          peerGroup,
          minYBehaviour,
          minY,
          maxY,
          maxYBehaviour,
          useEntityAsScope,
          type: 'GroupVsRemainder' as VisualisationDefinitions.GadgetType,
          dataset,
          field,
          limit: 20,
          trendByCalendarInterval: interval,
        } as VisualisationDefinitions.GroupVsRemainder;
      }
    })();

    setDraftGadget(newDraftGadget);
    if (onChange) {
      onChange(newDraftGadget);
    }
  }, [
    dataset,
    description,
    field,
    id,
    interval,
    maxY,
    maxYBehaviour,
    minY,
    minYBehaviour,
    name,
    onChange,
    peerGroup,
    useEntityAsScope,
  ]);

  const isPreviewReady = dataset !== undefined && field !== undefined;
  const isValid = isPreviewReady && name !== '';

  return (
    <GroupVsRemainderForm
      draftGadget={gadget}
      isLoading={false}
      name={name}
      dataset={dataset}
      field={field}
      setDataset={setDataset}
      peerGroup={peerGroup}
      setPeerGroup={setPeerGroup}
      setField={setField}
      setName={setName}
      isValid={isValid}
      description={description}
      setDescription={setDescription}
      interval={interval}
      minYBehaviour={minYBehaviour}
      setMinYBehaviour={setMinYBehaviour}
      minY={minY}
      setMinY={setMinY}
      maxYBehaviour={maxYBehaviour}
      setMaxYBehaviour={setMaxYBehaviour}
      maxY={maxY}
      setMaxY={setMaxY}
      setInterval={setInterval}
      isNewGadget={isNewGadget}
      useEntityAsScope={useEntityAsScope}
      setUseEntityAsScope={setUseEntityAsScope}
    />
  );
};

export default GroupVsRemainderFormContainer;
